<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :auto-select-first-row="false"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        @selectionChanged="rowSelectionChanged"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        class="btn primary small outline"
        :disabled="selectedRows.length == 0"
        @click="deleteChargeService"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="selectedRows.length == 0"
        class="btn primary small"
        @click="editChargeService"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="dialogFormVisible = true">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="isEdit ? $t('dialog.chargeFeeUpdate') : $t('dialog.chargeFeeAdd')"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:20"
                  name="Mã phí dịch vụ"
                >
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.code') }}:</div>
                    <div class="child-w-80">
                      <input
                        v-model="serviceChargeItem.code"
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|integer|percent"
                  name="Mức phí"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.chargeFeeLevel') }}:
                    </div>
                    <div class="child-w-80">
                      <input v-model="serviceChargeItem.level" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max: 200" name="Mô tả">
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.desc') }}:</div>
                    <div class="child-w-80">
                      <textarea v-model="serviceChargeItem.desc" rows="4" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateChargeService"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addChargeService">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import {
  getListChargeServiceApi,
  addChargeServiceApi,
  updateChargeServiceApi,
  deleteChargeServiceApi
} from '@/api/configuration/accounting/chargeService.js'
import { Message } from 'element-ui'
export default {
  data() {
    return {
      selectedRows: [],
      loading: false,
      columns: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          tooltipField: 'code',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.chargeFeeLevel'),
          field: 'level',
          tooltipField: 'level',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          tooltipField: 'desc'
        }
      ],
      rowId: null,
      rows: [],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        orderTp: 'ASC'
      },
      serviceChargeItem: {
        code: '',
        level: null,
        desc: '',
        order: 1
      }
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetServiceChargeItem()
    }
    // 'serviceChargeItem.level'() {
    //   alert(1)
    // }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    rowSelectionChanged(row) {
      this.selectedRows = row
    },
    resetServiceChargeItem() {
      this.isEdit = false
      this.serviceChargeItem = {
        code: '',
        level: 0,
        desc: '',
        order: 0
      }
    },
    // table controller
    onRowClick(index) {
      document.getElementById(`currency-${index}`).classList.add('row-focus')
      if (this.rowId != null) {
        document
          .getElementById(`currency-${this.rowId}`)
          .classList.remove('row-focus')
      }
      this.rowId = index
    },
    // CRUD
    async addChargeService() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await addChargeServiceApi(this.serviceChargeItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    editChargeService() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$alert('Vui lòng chọn loại phí dịch vụ', 'Error', {
          confirmButtonText: 'OK'
        })
        return false
      }
      this.isEdit = true
      this.dialogFormVisible = true
      Object.assign(this.serviceChargeItem, row)
    },
    async deleteChargeService() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      const id = row.id
      const id_list = []
      id ? id_list.push(id) : null
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteChargeFeeConfirm'), () => {
          deleteChargeServiceApi({
            id_list: id_list
          })
            .then(async res => {
              const message = res.message
              await this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    async updateChargeService() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await updateChargeServiceApi(this.serviceChargeItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      this.loading = true
      let data = await getListChargeServiceApi()
      this.loading = false
      this.rows = data.data
      this.selectedRows = []
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
